import { yupResolver } from '@hookform/resolvers/yup';
import { NewPaymentContext } from 'components/payment/payment.context';
import Spinner from 'components/spinner/spinner.component';
import { getSchema } from 'components/payment/spreedly/spreedly-card/spreedly-card.utils';
import { useContext } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import SpreedlyContext from 'components/payment/spreedly/spreedly.context';
import SpreedlyCheckoutSdkForm from './forms/spreedly-checkout-sdk-form.component';
import { useCheckoutPaymentLoading } from 'pages/checkout/checkout.component';
import { useSelector } from 'react-redux';
import { useIsNewSpreedlyCardFlow } from 'components/payment/payment-selector/credit-card-panel/credit-card-panel-controller/credit-card-panel-controller.hooks';
import { selectIsLoggedIn } from 'redux/user/user.selectors';

const SpreedlyCheckoutSdkCard = ({ handleCardInfo, button }) => {
  const { initOrderResponse, refetchInitOrder } = useContext(NewPaymentContext);
  const initOrderAttributes = initOrderResponse?.attributes;
  const formName = initOrderAttributes?.hostedPaymentPageName;
  const methods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    resolver: yupResolver(getSchema(formName)),
  });
  const {
    spreedlyScriptLoading,
    setCardInfo,
    setTokenizationSuccess,
    notifySpreedlyError,
  } = useContext(SpreedlyContext);
  const setPaymentLoading = useCheckoutPaymentLoading(
    state => state.setLoading,
  );
  const paymentLoading = useCheckoutPaymentLoading(state => state.loading);
  const addPromise = useCheckoutPaymentLoading(state => state.addPromise);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const isNewSpreedlyCardFlow = useIsNewSpreedlyCardFlow();
  const showSaveCardCheckbox = isLoggedIn && isNewSpreedlyCardFlow;

  const onSuccess = async (_token, paymentMethod) => {
    const { token, full_name, month, year } = paymentMethod;
    setTokenizationSuccess(true);
    if (!!handleCardInfo) {
      const res = await addPromise(
        handleCardInfo({ token, full_name, month, year }),
      );
      if (!res) await addPromise(refetchInitOrder());
    } else {
      // I cannot, for the life of me, get form values in here. They are
      // always undefined. So, I'm just querying the DOM directly for the checkbox.
      const savePaymentInstrument = document.getElementById(
        'savePaymentInstrument',
      )?.checked;
      setCardInfo({
        token,
        savePaymentInstrument,
        cardNickname: savePaymentInstrument ? full_name : undefined,
      });
    }
  };

  const onError = () => {
    setPaymentLoading(false);
    notifySpreedlyError();
  };

  return spreedlyScriptLoading ? (
    <Spinner />
  ) : (
    <FormProvider {...methods}>
      <SpreedlyCheckoutSdkForm
        formName={formName}
        initOrderAttributes={initOrderAttributes}
        onSuccess={onSuccess}
        onError={onError}
        onSubmitStart={() => setPaymentLoading(true)}
        showSaveCardCheckbox={showSaveCardCheckbox}
        button={button}
        disabled={paymentLoading}
      />
    </FormProvider>
  );
};

export default SpreedlyCheckoutSdkCard;
